// extracted by mini-css-extract-plugin
module.exports = {"dialog":"_3Aa4dDMi_4k4SBlbZDoFy1"};